
import {computed} from 'vue';

export function useBasePrinter(props) {
	
	const hasLink = computed(() => {
		return props.link !== null && props.link !== undefined;
	});
	
	function tdStyle(): string {
		if (props.style!==null && props.style!==undefined) {
			return props.style;
		}
		return "";
	}
	
	return  {hasLink, tdStyle};
}

